module.exports = require('./_hide');


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_redefine.js
// module id = 237
// module chunks = 0